import {
    BusinessRulesAttributes,
    BusinessRulesAttributesDurationLabels,
    BusinessRulesAttributesPointsLabels,
} from '../../../../constants/constants'

interface IRuleField {
    id: string
    [key: string]: unknown
}

export const handleUpdateRulesFields = (
    rulesFields: any[],
    resetValue: boolean = false,
): IRuleField[] => {
    // Store values for all fields
    const fieldValues: Record<string, any> = {}

    // collect all values
    rulesFields.forEach((item) => {
        const itemId = item.id?.toLowerCase()
        fieldValues[itemId] = item.value
    })
    const triggerMethodValue =
        fieldValues[BusinessRulesAttributes.TRIGGER_METHOD]
    const hasAggregate = fieldValues[BusinessRulesAttributes.AGGREGATE_LOW_HIGH]

    const updateRulesFields = rulesFields.map((item: any) => {
        const itemId = item.id?.toLowerCase()
        if (
            itemId === BusinessRulesAttributes.LOW_CRITICAL_DURATION ||
            itemId === BusinessRulesAttributes.HIGH_CRITICAL_DURATION ||
            itemId === BusinessRulesAttributes.LOW_WARNING_DURATION ||
            itemId === BusinessRulesAttributes.HIGH_WARNING_DURATION ||
            itemId === BusinessRulesAttributes.LOW_INFO_DURATION ||
            itemId === BusinessRulesAttributes.HIGH_INFO_DURATION ||
            itemId === BusinessRulesAttributes.CRITICAL_DURATION ||
            itemId === BusinessRulesAttributes.WARNING_DURATION ||
            itemId === BusinessRulesAttributes.INFO_DURATION
        ) {
            const itemID = itemId
            return {
                ...item,
                name:
                    triggerMethodValue === BusinessRulesAttributes.POINTS
                        ? BusinessRulesAttributesPointsLabels[itemID]
                        : BusinessRulesAttributesDurationLabels[itemID],
                hide:
                    itemId === BusinessRulesAttributes.CRITICAL_DURATION ||
                    itemId === BusinessRulesAttributes.WARNING_DURATION ||
                    itemId === BusinessRulesAttributes.INFO_DURATION
                        ? !hasAggregate
                        : hasAggregate,
                value: resetValue ? '' : item.value,
                errorMessage: '',
            }
        } else if (fieldsToUpdateErrorMessage.includes(itemId)) {
            return { ...item, errorMessage: '' }
        } else {
            return { ...item }
        }
    })
    return updateRulesFields
}

export const UpdateErrorMeassagesRulesFields = (
    rulesFields: any[],
): IRuleField[] => {
    // Collect all field values
    const fieldValues: Record<string, any> = {}
    rulesFields.forEach((item) => {
        fieldValues[item.id?.toLowerCase()] = item.value
    })
    const hasAggregate = fieldValues[BusinessRulesAttributes.AGGREGATE_LOW_HIGH]

    const fieldsToUpdateErrorMessageMap: Record<string, string[]> = hasAggregate
        ? {
              [BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]: [
                  BusinessRulesAttributes.CRITICAL_DURATION,
              ],
              [BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]: [
                  BusinessRulesAttributes.CRITICAL_DURATION,
              ],
              [BusinessRulesAttributes.LOW_WARNING_THRESHOLD]: [
                  BusinessRulesAttributes.WARNING_DURATION,
              ],
              [BusinessRulesAttributes.HIGH_WARNING_THRESHOLD]: [
                  BusinessRulesAttributes.WARNING_DURATION,
              ],
              [BusinessRulesAttributes.LOW_INFO_THRESHOLD]: [
                  BusinessRulesAttributes.INFO_DURATION,
              ],
              [BusinessRulesAttributes.HIGH_INFO_THRESHOLD]: [
                  BusinessRulesAttributes.INFO_DURATION,
              ],
              [BusinessRulesAttributes.CRITICAL_DURATION]: [
                  BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD,
                  BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD,
              ],
              [BusinessRulesAttributes.WARNING_DURATION]: [
                  BusinessRulesAttributes.LOW_WARNING_THRESHOLD,
                  BusinessRulesAttributes.HIGH_WARNING_THRESHOLD,
              ],
              [BusinessRulesAttributes.INFO_DURATION]: [
                  BusinessRulesAttributes.LOW_INFO_THRESHOLD,
                  BusinessRulesAttributes.HIGH_INFO_THRESHOLD,
              ],
          }
        : {
              [BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]: [
                  BusinessRulesAttributes.LOW_CRITICAL_DURATION,
              ],
              [BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]: [
                  BusinessRulesAttributes.HIGH_CRITICAL_DURATION,
              ],
              [BusinessRulesAttributes.LOW_WARNING_THRESHOLD]: [
                  BusinessRulesAttributes.LOW_WARNING_DURATION,
              ],
              [BusinessRulesAttributes.HIGH_WARNING_THRESHOLD]: [
                  BusinessRulesAttributes.HIGH_WARNING_DURATION,
              ],
              [BusinessRulesAttributes.LOW_INFO_THRESHOLD]: [
                  BusinessRulesAttributes.LOW_INFO_DURATION,
              ],
              [BusinessRulesAttributes.HIGH_INFO_THRESHOLD]: [
                  BusinessRulesAttributes.HIGH_INFO_DURATION,
              ],
              [BusinessRulesAttributes.LOW_CRITICAL_DURATION]: [
                  BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD,
              ],
              [BusinessRulesAttributes.HIGH_CRITICAL_DURATION]: [
                  BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD,
              ],
              [BusinessRulesAttributes.LOW_WARNING_DURATION]: [
                  BusinessRulesAttributes.LOW_WARNING_THRESHOLD,
              ],
              [BusinessRulesAttributes.HIGH_WARNING_DURATION]: [
                  BusinessRulesAttributes.HIGH_WARNING_THRESHOLD,
              ],
              [BusinessRulesAttributes.LOW_INFO_DURATION]: [
                  BusinessRulesAttributes.LOW_INFO_THRESHOLD,
              ],
              [BusinessRulesAttributes.HIGH_INFO_DURATION]: [
                  BusinessRulesAttributes.HIGH_INFO_THRESHOLD,
              ],
          }

    // Pre-calculate which fields should to remove errors
    const fieldsWithOutErrors = new Set<string>()

    Object.entries(fieldsToUpdateErrorMessageMap).forEach(
        ([field, relatedFields]) => {
            const isEmpty = relatedFields.reduce((hasValue, rf) => {
                const value = fieldValues[rf]
                return (
                    (value === null || value === '' || value === undefined) &&
                    hasValue
                )
            }, true)

            if (isEmpty) {
                fieldsWithOutErrors.add(field)
            }
        },
    )

    // Single pass over rulesFields to remove error messages
    const updatedRulesFields = rulesFields.map((item) => {
        const itemId = item.id?.toLowerCase()
        if (itemId === BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD) {
            const highCriticalThresholdValue =
                fieldValues[BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD]
            return {
                ...item,
                errorMessage:
                    item.value || highCriticalThresholdValue
                        ? ''
                        : 'One of the critical threshold is required',
            }
        } else if (itemId === BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD) {
            const lowCriticalThresholdValue =
                fieldValues[BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD]
            return {
                ...item,
                errorMessage:
                    item.value || lowCriticalThresholdValue
                        ? ''
                        : 'One of the critical threshold is required',
            }
        } else if (fieldsWithOutErrors.has(itemId)) {
            return { ...item, errorMessage: '' }
        }

        return item
    })

    return updatedRulesFields
}

export const fieldsToUpdateErrorMessage: string[] = [
    BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD,
    BusinessRulesAttributes.HIGH_CRITICAL_THRESHOLD,
    BusinessRulesAttributes.LOW_WARNING_THRESHOLD,
    BusinessRulesAttributes.HIGH_WARNING_THRESHOLD,
    BusinessRulesAttributes.LOW_INFO_THRESHOLD,
    BusinessRulesAttributes.HIGH_INFO_THRESHOLD,
    BusinessRulesAttributes.LOW_CRITICAL_DURATION,
    BusinessRulesAttributes.HIGH_CRITICAL_DURATION,
    BusinessRulesAttributes.LOW_WARNING_DURATION,
    BusinessRulesAttributes.HIGH_WARNING_DURATION,
    BusinessRulesAttributes.LOW_INFO_DURATION,
    BusinessRulesAttributes.HIGH_INFO_DURATION,
    BusinessRulesAttributes.LOW_CRITICAL_THRESHOLD,
    BusinessRulesAttributes.CRITICAL_DURATION,
    BusinessRulesAttributes.WARNING_DURATION,
    BusinessRulesAttributes.INFO_DURATION,
]
